export enum EDiscountCodeType {
	FIXED = 'fixed',
	PERCENTAGE = 'percentage',
}
